// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".youtubeVideoBlock[data-v-533ab327]  .plyr__control--overlaid{background:#ffcbc4 !important}.youtubeVideoBlock[data-v-533ab327]  input[type=range]{color:#ffcbc4 !important}.youtubeVideoBlock[data-v-533ab327]  .plyr__control:hover{background:#ffcbc4}", ""]);
// Exports
module.exports = exports;
